<template>
  <div class="input-group">
    <div class="input-group-addon w-100-p text-center p-all-0">
      <span class="inline-block h-auto m-t-5">
        <div v-if="!image && (type == 1 || type == 2)" class="text-black" v-text="'沒有圖片'" />
        <img :src="image" :id="'img-load' + index + '-' + type" class="h-auto img-responsive" v-if="image" data-toggle="modal" :data-target="'#myModal-' + index + '-' + type">
      </span>
    </div>
    <div class="form-control h-100">
      <label :for="'file-upload-' + index + '-' + type" class="btn-upload btn btn-default" style="margin-top: 25px;">
        選擇圖片
      </label>
      <input :id="'file-upload-' + index + '-' + type" class="form-control" type="file" style="display: none;" @change="onFileChange">
    </div>
    <!-- Modal -->
    <div class="modal fade" :id="'myModal-' + index + '-' + type" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal"><span aria-hidden="true">&times;</span><span class="sr-only">Close</span></button>
            <h4 class="modal-title" id="myModalLabel">廣告</h4>
          </div>
          <div class="modal-body">
            <img :src="image" class="img-responsive">
            </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-default" data-dismiss="modal">返回</button>
            <!--<button type="button" class="btn btn-primary">Save changes</button>-->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import $ from 'jquery'
export default{
  props: ['index', 'type'],
  data () {
    return {
      image: '',
      img: {
        width: 0,
        height: 0
      }
    }
  },
  methods: {
    onFileChange (e) {
      var files = e.target.files || e.dataTransfer.files
      if (!files.length) return
      let imgName = files[0].name.split('.')
      if (imgName.length < 2 || !imgName[imgName.length - 1].match(/(jpg|jpeg|png)$/i)) {
        this.$notify({
          title: '提醒',
          text: '圖片格式錯誤！',
          duration: 3000,
          type: 'danger',
          width: 400
        })
        // $('#file-upload').replaceWith($('#file-upload').val(''))
      } else {
        this.createImage(files[0])
      }
    },
    createImage (file) {
      var reader = new FileReader()
      var self = this
      reader.onload = (e) => {
        var img = new Image()
        img.src = e.target.result
        self.image = img.src
        // $('#img-load' + this.index + '-' + this.type).attr('src', img.src)
        img.onload = () => {
          self.img.width = img.width
          self.img.height = img.height
        }
      }
      $('.img-size').css('background', 'white')
      reader.readAsDataURL(file)
    }
  }
}
</script>
<style scoped>
.modal, .modal * {
  height: auto !important;
}
</style>



// WEBPACK FOOTER //
// ImgUploadTemp.vue?1b640e0e